<template>
  <v-container>
    <v-row :class="['row-cabecera']">
      <v-col cols="12" xs="2" sm="2" md="3" lg="2" xl="1"
        class="d-flex flex-column justify-center align-center flex-shrink-0"
      >
         <v-card
          outlined
          class="card-header-icon d-flex align-center justify-center tooltip"
          @click="redirectToPage()"
        >
          <img
            :class="['card-icon']"
            :src="require('@/assets/Frameicon-lupa.png')"
          />

          <div class="tooltiptext">
            <v-img
              :src="require('@/assets/pregunta-tus-datos.png')"
              height="150"
              width="322"
            ></v-img>
          </div>
        </v-card>
        

        <v-card
          outlined
          class="card-header-icon d-flex align-center justify-center tooltip"
          @click="redirectToMetabase()"
        >
          <img
            :class="['card-icon']"
            :src="require('@/assets/icon-metabase.png')"
          />

          <div class="tooltiptext">
            <v-img
              :src="require('@/assets/metabase.png')"
              height="150"
              width="322"
            ></v-img>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" xs="9" sm="9" md="8" lg="9" xl="11"
        class="d-flex align-center flex-wrap"
      > 
        <!-- <v-row class="d-flex flex-row align-center"> -->
          <!-- Indicador 1-->
          <div class="indicador-container">
            <v-img 
              :class="['indicador-image']"
              :src="require('@/assets/indicadores/ind1.png')"
            ></v-img>

            <div :class="['indicador-ubicacion']">
              <div v-if="isLoading" style="margin-bottom: 8px;">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </div>
              <div
                v-else
                class="indicador-value"
              >
                {{formatValue(dataIndicadores[0], false)}}
              </div>
              <div
                class="indicador-descripcion"
              >
                Distribuidoras al Día
              </div>
            </div>
          </div>

          <!-- Indicador 2-->
          <div class="indicador-container">
            <v-img 
              :class="['indicador-image']"
              :src="require('@/assets/indicadores/ind2.png')"
            ></v-img>

            <div class="indicador-ubicacion">
              <div v-if="isLoading" style="margin-bottom: 8px;">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </div>
              <div
                v-else
                class="indicador-value"
              >
                {{formatValue(dataIndicadores[1], true)}}
              </div>
              <div
                class="indicador-descripcion"
              >
                Ventas
              </div>
            </div>
          </div>

          <!-- Indicador 3-->
          <div class="indicador-container">
            <v-img 
              :class="['indicador-image']"
              :src="require('@/assets/indicadores/ind3.png')"
            ></v-img>

            <div class="indicador-ubicacion">
              <div v-if="isLoading" style="margin-bottom: 8px;">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </div>
              <div
                v-else
                class="indicador-value"
              >
                {{formatValue(dataIndicadores[2], false)}}
              </div>
              <div
                class="indicador-descripcion"
              >
                Reportes Visitados
              </div>
            </div>
          </div>

          <!-- Indicador 4-->
          <div class="indicador-container">
            <v-img 
              :class="['indicador-image']"
              :src="require('@/assets/indicadores/ind4.png')"
            ></v-img>

            <div class="indicador-ubicacion">
              <div v-if="isLoading" style="margin-bottom: 8px;">
                <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </div>
              <div
                v-else
                class="indicador-value"
              >
                {{formatValue(dataIndicadores[3], false)}}
              </div>
              <div
                class="indicador-descripcion"
              >
                Cobertura
              </div>
            </div>
          </div>
        <!-- </v-row> -->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import uris from '../../utils/uris'
import axios from '../../utils/axiosWrapper'

export default {
  name: 'header-main-page',
  data () {
    return {
      dataIndicadores: [],
      isLoading: true
    }
  },
  methods: {
    redirectToPage () {
      // window.location.assign('http://softys25.strategio.cloud')
      if (uris.URL_POWERBI_ID.length === 0) return
      this.$router.push({name: 'ShowReportBi'})
    },
    redirectToMetabase () {
      // this.$router.push({name: 'ShowMetabase'})
      if (uris.URL_METABASE.length === 0) return
      window.open(uris.URL_METABASE, '_blank', 'toolbar=0,location=0,menubar=0')
    },
    getKpi () {
      axios.get(uris.URL_GET_KPI)
        .then((response) => {
          this.isLoading = false
          this.dataIndicadores = response.data.rows
        }, (err) => {
          this.isLoading = false
          console.warn('No se ha podido obtener data de kpi', err)
        })
    },
    formatValue (kpi, dollarSign = false) {
      let value = 0
      if (this.dataIndicadores.length > 0) {
        // return kpi.data.toLocaleString('en-US', {maximumFractionDigits: 0})
        // Nine Zeroes for Billions
        value = Math.abs(Number(kpi.data)) >= 1.0e+9
          ? (Math.abs(Number(kpi.data)) / 1.0e+9).toFixed(2) + 'B'
          // Six Zeroes for Millions
          : Math.abs(Number(kpi.data)) >= 1.0e+6
            ? (Math.abs(Number(kpi.data)) / 1.0e+6).toFixed(2) + 'M'
            // Three Zeroes for Thousands
            : Math.abs(Number(kpi.data)) >= 1.0e+3
              ? (Math.abs(Number(kpi.data)) / 1.0e+3).toFixed(0) + 'K'
              : Math.abs(Number(kpi.data))
      }
      return dollarSign ? 'S/.' + value : value
    }
  },
  mounted () {
    this.getKpi()
  }
}
</script>

<style>

.logo {
  width: 10vw; /* 205 */
  min-width: 100px;
}

.row-cabecera {
  margin-top: 65px;
  margin-bottom: 65px;
  /* background-color: black; */
}

.card-header-icon {
  min-width: 100px;
  height: 100px;
  background-color: #FFFFFF;
  box-shadow: 0px 0px 80px 0px rgba(0, 0, 0, 0.2);
  border-radius: 10%;
  margin-right: 0.1vw; /* 11px; */
  margin-left: 0.14vw; /* 20px; */
  margin-top: 0.14vw;  /* 20px; */
}

.card-header-icon:nth-child(even) {
  margin-top: 30px
}

.card-icon {
  max-width: 6vw; 
  max-height: 7vh;
  
  min-width: 41px; 
  min-height: 41px;
}

.indicador-container {
  position: relative;
  text-align: center;
  color: white;
  margin-left: 20px;
  margin-top: 20px;
  max-width: 347px;
  min-width: 250px;
  max-height: 230px;
  min-height: 150px;
}

.indicador-image {
  width: 24vw;
  height: 30vh;
  min-width: 250px;
  border-radius: 5%;
  max-height: 230px;
  min-height: 150px;
}

.indicador-ubicacion {
  position: absolute;
  left: 29px;
  top: 43px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.indicador-value {
  font-family: 'Nexa-Bold';
  font-style: normal;
  font-weight: 400;
  font-size: 34px;
  line-height: 34px;
  margin-bottom: 8px;
}

.indicador-descripcion {
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 20px;
}

/* Tooltip container */
.tooltip {
  position: relative;
  display: inline-block;
  border-bottom: 1px dotted black; /* If you want dots under the hoverable text */
}

/* Tooltip text */
.tooltip .tooltiptext {
  visibility: hidden;
  opacity: 0;
  height: 150;
  width: 322px;
  background-color: white;
  color: #fff;
  text-align: center;
  padding: 5px 0;
  box-shadow: 40px 30px 80px rgba(0, 0, 0, 0.08), 0px 0px 140px rgba(0, 0, 0, 0.1) !important;
  border-radius: 10px !important;
  top: -1px;
  left: 115%;
 
  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
  transition: all .4s;
}

/* Show the tooltip text when you mouse over the tooltip container */
.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

</style>


// WEBPACK FOOTER //
// src/components/header-main-page/header-main-page.vue